import { RolePermissionModel } from './../definition/permission.model';
import { Injectable, Injector } from '@angular/core';
import { GenericApiService } from 'shared/services';
import { HttpClient } from '@angular/common/http';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Injectable({
  providedIn: 'root'
})
export class PermissionApiService extends GenericApiService<RolePermissionModel,any> {

    

  constructor(injector: Injector) {
    super(injector, "rolepermission");
  }

  getPermissionList() {
    return this.httpClient.get<NzTreeNodeOptions[]>(`api/${this.typeName}/GetPermissionList`);
  }

  getRolePermissionList(id:string) {
    return this.httpClient.get<RolePermissionModel>(`api/${this.typeName}/${id}/permissions`);
  }

  saveRolePermission(params:RolePermissionModel) {
    return this.httpClient.put<RolePermissionModel>(`api/${this.typeName}/${params.roleId}/permissions`,params);
  }

  getUserPermissionList(userid:string) {
    return this.httpClient.get<RolePermissionModel>(`api/${this.typeName}/${userid}/userpermissions`);
  }

}